<template>
<div class="fc-page mg-page mg-course_list"><nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="mg-breadcrumb"/></nav><header class="fc-heading"><div class="fc-child-heading"><h1>课程管理</h1><p>维护课程信息，按校区账户模式设置扣费方式</p></div><div class="mg-heading-actions"><v-btn @click="showAddDialog"  color="#d9363e" depressed class="mg-create">添加课程</v-btn></div></header><section class="fc-filters" aria-label="课程管理筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>按条件查找需要的记录</span></div><form @submit.prevent="queryClicked"><div class="fc-filter-grid"><div class="fc-filter-cell"><v-text-field clearable dense label="课程名称" outlined v-model="query.courseName" color="#d9363e" aria-label="课程名称">
							</v-text-field></div>
<div class="fc-filter-cell"><v-select :items="statusItems" v-model="query.status"
							item-text="statusName" item-value="id"  label="课程状态" dense outlined color="#d9363e" aria-label="课程状态"></v-select></div></div><div class="fc-filter-bottom"><span>设置条件后点击查询</span><v-btn type="submit" color="#d9363e" dark depressed class="mg-query"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></form></section><section class="fc-records" aria-label="课程列表"><div class="fc-list-heading"><h3>课程列表</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div><v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table mg-table fc-has-actions"
			disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......" :mobile-breakpoint="0" no-data-text="暂无符合条件的记录">


			<template v-slot:item.status="{item}">
				<span v-if="item.status=='1'">正常</span>
				<span v-if="item.status=='0'" style="color:red">已作废</span>
			</template>
			<template v-slot:item.consumeType="{item}">
				<span v-if="item.consumeType=='1'">{{ consumeTypeName(item.consumeType) }}</span>
				<span v-if="item.consumeType=='2'" style="color:#E65100">{{ consumeTypeName(item.consumeType) }}</span>
			</template>
			<template v-slot:item.consumePrice="{item}">
				{{ item.consumePrice }}
			</template>

			<template v-slot:item.action="{item}">
				<v-btn @click.stop="showUpdate(item)" color="#d9363e" small depressed>修改</v-btn>
				<v-btn v-if="item.status =='1'" @click.stop="frozen(item)" color="#d9363e" small class="ml-1" depressed>作废</v-btn>
				<v-btn v-if="item.status =='0'" @click.stop="free(item)" color="#d9363e" small class="ml-1" depressed>启用</v-btn>
			</template>

		</v-data-table><div class="fc-pagination"><div class="fc-page-size"><v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
						outlined v-model="query.size" color="#d9363e" aria-label="每页数量" /><span>条 / 页</span><span class="fc-total">共 {{data.total}} 条</span></div><div v-if="Math.ceil(data.total/query.size)>0" class="mg-pagination"><v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
						:total-visible="5" v-model="query.page" color="#d9363e" /></div></div></section><v-dialog title="修改课程" v-model="update.dialog" max-width="600" persistent scrollable>
		<v-card class="fc-dialog-card mg-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-book-open-page-variant-outline</v-icon></span><div class="mg-dialog-title"><h2><span>修改课程信息</span></h2><p>完善信息后保存修改</p></div><v-spacer/><v-btn icon aria-label="关闭修改课程" @click="update.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

			<v-card-text class="fc-dialog-body">
				<v-row dense>

					<v-col cols="12">
						<v-text-field label="课程名称" v-model="update.course.courseName" dense outlined color="#d9363e" aria-label="课程名称"></v-text-field>
					</v-col>
					<v-col cols="12">
						<v-select :loading="modesLoading" :disabled="modesLoading" :items="consumeTypes" v-model="update.course.consumeType"
						item-text="typeText" item-value="typeValue"  label="扣费方式" dense outlined color="#d9363e" aria-label="扣费方式"></v-select>
					</v-col>
					<v-col cols="12">
						<v-text-field type="number" label="标准课时单价" v-model="update.course.consumePrice" dense outlined color="#d9363e" aria-label="标准课时单价"></v-text-field>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="update.dialog=false" depressed>取消</v-btn>
				<v-btn @click="submitUpdateCourse" :loading="update.submiting" color="#d9363e" depressed class="fc-confirm">确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
<courseCreate :show="add.dialog" @cancel="add.dialog=false" @success="courseCreated"></courseCreate></div>
</template>

<script>
	import {fetchAccountModes,consumeOptions} from '../../../config/accountModes'
	import utils from "../../../config/utils"
	import courseCreate from "../../../components/course_create.vue"
	export default {
		name: "course-list",
		components:{courseCreate},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '系统管理',
						disabled: true
					},
					{
						text: '课程管理',
						disabled: true
					},
				],
				data: {
					total: 0,
					headers: [{
							text: '课程名称',
							value: 'courseName',
							sortable: false
						},
						
						{
							text: '扣费方式',
							value: 'consumeType',
							sortable: false
						},
						{
							text: '标准课时单价',
							value: 'consumePrice',
							sortable: false
						},
						{
							text: '班级数',
							value: 'onlineClassQty',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				search: "",
				consumeTypes:[],
 modesLoading:false, modesError:"", originalConsumeType:"", modeShopId:"", modesRequest:0,
				statusItems:[
					{id:'',statusName:"全部"},
					{id:'1',statusName:"正常"},
					{id:'0',statusName:"已作废"},
				],
				selectShopList:[], //选择门店数据源
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					courseName: "",
					status: "1"
				},
				add: {
					dialog: false,
				},
				update: {
					dialog: false,
					submiting:false,
					course: {
						id:"",
						courseName: "",
						consumeType:"",
						consumePrice: "",
						briefDesc:""
					}
				},
			}
		},
		created() {
		
			this.getCourseList();
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getCourseList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getCourseList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getCourseList();
			},
			
			showAddDialog() {
				this.add.dialog = true;
			},
			
			getCourseList() {
				const that = this;
				this.query.loading = true;
				
				const shopId = utils.getCurrentShopId();

				let url = `/edu/course/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (shopId) {
					url += "&shopId=" + shopId;
				}
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.courseName) {
					url += "&courseName=" + this.query.courseName;
				}
				if (this.query.status) {
					url += "&status=" + this.query.status;
				}


				this.axios.get(url).then(response => {
					
					console.log(response);
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			consumeTypeName(state){
				let stName = "未知";
				if (state === "1") {
					stName = "按课时扣费";
				} else if (state === "2") {
					stName = "按金额扣费";
				}
				return stName;
			},
			frozen(item){
				// api
				const that = this;
				let url = `/edu/course/frozen/${item.id}`;
							
			
				this.axios.post(url).catch(() => {
	
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("作废成功");
							that.getCourseList();
							
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
			},
			free(item){
				// api
				const that = this;
				let url = `/edu/course/free/${item.id}`;
							
			
				this.axios.post(url).catch(() => {
				
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("启用成功");
							that.getCourseList();
							
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
			},
			consumeTypeColor(state){
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "2") {
					color = "warning";
				}
				
				return color;
			},
			courseStatusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "冻结";
				}
				return stName;
			},
			courseStatusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			courseCreated(){
				this.getCourseList();
				this.add.dialog = false;
			},
			async showUpdate(item) {
				this.update.dialog = true;
				this.update.course.id = item.id;
				this.update.course.courseName = item.courseName;
				this.update.course.consumeType = item.consumeType;
				this.update.course.consumePrice = item.consumePrice;
 this.originalConsumeType=item.consumeType;this.consumeTypes=[];this.modesLoading=true;this.modesError="";
 const seq=++this.modesRequest, shopId=utils.getCurrentShopId();this.modeShopId=String(shopId||"");
 try{const modes=await fetchAccountModes(this.axios,shopId);if(seq!==this.modesRequest)return;this.consumeTypes=consumeOptions.filter(x=>modes.includes(x.typeValue)||x.typeValue===item.consumeType).map(x=>({...x,typeText:x.typeText+(modes.includes(x.typeValue)?"":"（原扣费方式）")}))}
 catch(e){if(seq===this.modesRequest){this.modesError=e.message;this.$noty.error(e.message)}}
 finally{if(seq===this.modesRequest)this.modesLoading=false}
			},
			submitUpdateCourse() {
 if(this.modesLoading||this.update.submiting)return;
 if(this.modesError||!this.consumeTypes.some(x=>x.typeValue===this.update.course.consumeType)){this.$noty.error("请重新打开表单获取校区账户类型");return}
 if(this.modeShopId!==String(utils.getCurrentShopId()||"")){this.$noty.error("校区已变化，请重新打开表单");return}

			
				if (!this.update.course.courseName) {
					this.$noty.error('课程名称不能为空');
					return
				}
				
				if (!this.update.course.consumeType) {
					this.$noty.error('扣费方式不能为空');
					return
				}
				
				if (!this.update.course.consumePrice) {
					this.$noty.error('价格不能为空');
					return
				}
				this.update.submiting = true;
				// api
				const that = this;
				let url = `/edu/course/update`;
			
				const updateData = {
					...this.update.course
				}
				
				this.axios.post(url, updateData).catch(() => {
					that.update.submiting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.update.submiting = false;
							that.$noty.success("修改成功");
							that.update.dialog = false;
							that.getCourseList();
							
							return;
						} else {
							that.update.submiting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.update.submiting = false;
						that.$noty.error('网络请求失败');
					}

				});
			},
			
			

		}
	}
</script>
<style>
</style>
<style lang="scss" scoped src="../../../assets/styles/management.scss"></style>
